const VARIANTS = {
  h1: "text-4xl font-bold",
  h2: "text-3xl font-bold",
  h3: "text-2xl font-semibold",
  h4: "text-xl font-semibold m-0",
  h5: "text-lg font-semibold",
  h6: "text-base font-semibold",
  subtitle1: "text-base font-medium",
  subtitle2: "text-sm font-medium",
  text1: "text-base",
  text2: "text-sm",
  span1: "text-base",
  span2: "text-sm",
  caption: "text-xs",
  span3: "text-[14px]",
};
const ELEMENT_MAP = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "p",
  subtitle2: "p",
  text1: "p",
  text2: "p",
  span1: "span",
  span2: "span",
  caption: "span",
};
const mergeClasses = (...classes) => {
  return classes.filter(Boolean).join(" ").trim();
};

const Typography = ({ variant = "text1", component, className = "", children, ...props }) => {
  const Component = component || ELEMENT_MAP[variant] || "p";
  const variantClasses = VARIANTS[variant] || VARIANTS.text1;
  return (
    <Component className={mergeClasses(variantClasses, className)} {...props}>
      {children}
    </Component>
  );
};

export default Typography;
